var UnavailabilityReason;
(function (UnavailabilityReason) {
  UnavailabilityReason["NO_REACH_PROFILE"] = "NO_REACH_PROFILE";
  UnavailabilityReason["NO_CATALOG_ITEMS"] = "NO_CATALOG_ITEMS";
  UnavailabilityReason["NO_REACH_PERMISSION"] = "NO_REACH_PERMISSION";
  UnavailabilityReason["NO_CAPTIONS"] = "NO_CAPTIONS";
  UnavailabilityReason["ENTRY_NOT_READY"] = "ENTRY_NOT_READY";
  UnavailabilityReason["ENTRY_DURATION_LESS_THAN_MIN"] = "ENTRY_DURATION_LESS_THAN_MIN";
  UnavailabilityReason["ENTRY_TYPE_NOT_SUPPORTED"] = "ENTRY_TYPE_NOT_SUPPORTED";
  UnavailabilityReason["NO_RECORDING"] = "NO_RECORDING";
  UnavailabilityReason["GENERAL_ERROR"] = "GENERAL_ERROR";
  UnavailabilityReason["AI_CONSENT"] = "AI_CONSENT";
})(UnavailabilityReason || (UnavailabilityReason = {}));

export { UnavailabilityReason };
